/* jshint esnext: true */

class SceneLoad extends Phaser.Scene {

	constructor() {

		super( { key: 'SceneLoad' } );

	}

	/**
	 *
	 */
	preload() {

		let listLength = Object.keys( tilesets ).length;

		/**
		 * Load all the different maze graphics.
		 */
		for ( let i = 1; i <= listLength; i++ ) {

			let path = '';
			let key = '';

			// Load map assets.
			path = `/assets/images/maze${i}.png`;
			key = 'maze' + i;
			this.load.image( key, path );

			// Load character assets.
			path = `/assets/images/character${i}.png`;
			key = 'character' + i;
			this.load.spritesheet(
				key,
				path,
				{
					frameWidth: 16,
					frameHeight: 24,
				}
			);

		}

		/**
		 * Load the addon collectibles.
		 */
		this.load.spritesheet(
			'addon-money',
			'/assets/images/addon-money.png',
			{
				frameWidth: 16,
				frameHeight: 16,
			}
		);

		this.load.spritesheet(
			'addon-money-10',
			'/assets/images/addon-money-10.png',
			{
				frameWidth: 16,
				frameHeight: 16,
			}
		);

		this.load.spritesheet(
			'addon-time',
			'/assets/images/addon-time.png',
			{
				frameWidth: 16,
				frameHeight: 16,
			}
		);

		this.load.spritesheet(
			'addon-energy',
			'/assets/images/addon-energy.png',
			{
				frameWidth: 16,
				frameHeight: 16,
			}
		);

	}


	/**
	 *
	 */
	create() {

		gameInit();

		gameCharacter.addAnimations( this );

		stateController.set( 'main-menu' );

	}

}
